module.exports = __webpack_public_path__ + "media/images/lp_consultation/message-device-large-1b368c22d793567e747b212f211536cc.png";